// Copyright (c) 2020-2021 Visual Intelligence LP. All rights reserved.
//
import * as React from 'react';
// import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import { SvgIcon, SvgIconProps } from '@mui/material';

type EmptyCommentsIconProps = SvgIconProps

const EmptyCommentsIcon: React.FC<EmptyCommentsIconProps> = (props) => {
  return (
    <SvgIcon width="64" height="64" viewBox="0 0 64 64" fill="none" {...props}>
      <g clipPath="url(#clip0)">
        <path d="M0 3.22656V42.1206H11.2567V53.3736L28.7996 42.1206H54.6167V3.22656H0ZM57.1863 11.7762V16.6705H59.1057V44.4071H49.6652V51.8211L38.7143 44.7971L38.1101 44.4072H29.8549L22.2268 49.3014H36.6686L50.7893 58.3557L54.5594 60.7723V49.3014H64V11.7762H57.1863Z" fill="#0870d8" />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="64" height="64" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export default EmptyCommentsIcon;
